import { number, object, string, boolean } from 'yup';

export default object().shape({
  numero_cancela: number().required('Este campo é obrigatório!'),
  tipo_cancela: string().required('Este campo é obrigatório!'),
  ip_camera_dianteira: string().required('Este campo é obrigatório!'),
  ip_controladora: string().required('Este campo é obrigatório!'),
  atuar_na_cancela: boolean().required('Este campo é obrigatório!')
})